import React from 'react';

const NovaiTheme = {
  headerLogo: {
    src: '/themes/theme/novai/logo.svg',
    alt: 'NOVAI influencers',
  },
  darkLogo: {
    src: '/themes/theme/novai/logo.svg',
    alt: 'NOVAI influencers',
    size: 100,
  },
  headerStyle: {
    backgroundColor: '#FFF',
    borderBottom: '2px solid #000',
  },
  linkStyle: {
    color: '#000',
    fontWeight: 800,
    fontSize: '120%',
  },
  title: 'NOVAI | CAMPAIGNS',
  isLightOnDark: false,
  loginMessage: (
    <div style={{ padding: '10px' }}>
      <img height="70" src="/themes/theme/novai/logo.svg" alt="NOVAI Influencers" />
      <br />
    </div>
  ),
  shareSite: 'https://reports.novaiinfluencer.ai',
};

export default NovaiTheme;



/** WEBPACK FOOTER **
 ** ./src/themes/theme/novai.js
 **/